import { GridContainer } from 'libs/ui';
import { SoAll } from 'grids/soall/soall';

export const SoAllWrapper = (props) => {
  return (
    <GridContainer>
      <SoAll {...props} />
    </GridContainer>
  );
};
